export default "__VITE_ASSET__ea102814__"